// extracted by mini-css-extract-plugin
export var addButton = "_d0-0";
export var border = "_d0-8";
export var check = "_d0-h";
export var danger = "_d0-6";
export var dropdownContainer = "_d0-1";
export var editModalBody = "_d0-j";
export var footerContainer = "_d0-i";
export var fullWidth = "_d0-a";
export var hide = "_d0-9";
export var icon = "_d0-3";
export var input = "_d0-7";
export var inputFlex = "_d0-b";
export var inputWrapper = "_d0-c";
export var manualFocus = "_d0-5";
export var optionButton = "_d0-4";
export var pillWrapper = "_d0-e";
export var pointer = "_d0-2";
export var showOverflow = "_d0-f";
export var tagsFlex = "_d0-d";
export var xButton = "_d0-g";